module.exports = __webpack_public_path__ + "img/divergancy_logo.b749301c.svg";